const state = {
    isCollapse: false,
    currentMenu: null,
    tabsList: [
        {
            path: '/',
            label: '数据概览',
            name: 'overview'
        }
    ],
    cachedViews: ['overview'],  //缓存的页面
}
const mutations = {
    selectMenu (state, val) {
        if (val.name !== 'overview') {
            state.currentMenu = val;
            let result = state.tabsList.findIndex(item => item.name === val.name);
            result === -1 ? state.tabsList.push(val) : ''
            // 添加页面缓存菜单
            result === -1 ? state.cachedViews.push(val.name) : ''
        } else {
            state.currentMenu = null
        }
    },
    collapseMenu (state) {
        state.isCollapse = !state.isCollapse
    },
    closeTab (state, val) {
        let result = state.tabsList.findIndex(item => item.name === val.name);
        state.tabsList.splice(result, 1);
        // 删除缓存页面
        state.cachedViews.splice(result, 1);
    }
}
const actions = {


}
const getters = {

}
export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}